import { Mesh, MeshBasicMaterial, Object3D } from "three";
import { clone } from "three/examples/jsm/utils/SkeletonUtils.js";
import { GameResourcesPackage } from "../../../resources/GameResourcesPackage";
import { IDamageable } from "../IDamageable";
import { VegetableType } from "../../../models/data/VegetableType";
import { Event } from "event-system";

export class Vegetable extends Object3D implements IDamageable {
    public readonly isDamageable: boolean = true;
    private static readonly ASSET_STATE_FORMAT = "{0}_state_{1}";
    public readonly eaten: Event;
    private readonly vegetableType: VegetableType;
    private _state: number;
    private get state(): number {
        return this._state;
    }
    private set state(value: number) {
        if (this._state === value) {
            return;
        }

        this._state = Math.min(value, 4);
        if (this._state === 4) {
            this.vegetableObject.visible = false;
            this.eaten.emit();
        } else {
            const assetName = Vegetable.ASSET_STATE_FORMAT.replace("{0}", this.vegetableType).replace("{1}", this._state.toString());
            const oldObject = this.vegetableObject;
            this.vegetableObject = clone(this.gameResources.assets_game_Vegetables_glb.scene.getObjectByName(assetName));
            this.vegetableObject.rotation.y = oldObject.rotation.y;
            this.remove(oldObject);
            this.add(this.vegetableObject);
        }
    }
    private vegetableObject: Object3D;
    private ground: Mesh;

    public get alive(): boolean {
        return this.state != 4;
    }

    public get vegetableObjectForTractor(): Object3D {
        return this.vegetableObject;
    }

    public constructor(
        private readonly gameResources: GameResourcesPackage,
    ) {
        super();
        this.vegetableType = this.randomVegetableType();
        this._state = 1;
        const assetName = Vegetable.ASSET_STATE_FORMAT.replace("{0}", this.vegetableType).replace("{1}", this._state.toString());
        this.vegetableObject = clone(this.gameResources.assets_game_Vegetables_glb.scene.getObjectByName(assetName));
        this.ground = clone(this.gameResources.assets_game_Vegetables_glb.scene.getObjectByName("VegetablesGround")) as Mesh;
        (this.ground.material as MeshBasicMaterial).transparent = true;
        this.ground.position.setY(0.01);
        this.vegetableObject.rotation.y = Math.random() * 360;
        this.add(this.ground, this.vegetableObject);
        this.eaten = new Event();
    }

    public takeDamage(_amount: number): void {
        this.state++;
    }

    public restore(): void {
        this.state = 1;
    }

    private randomVegetableType(): VegetableType {
        const values = Object.values(VegetableType);
        return values[Math.round(Math.random() * (values.length - 1))];
    }
}
